import { Navbar } from "../components/Navbar";

export function FreelancePage() {
    return(
        <div class="">
            <Navbar />
            <h1>Coming soon!</h1>
        </div>
    );
};
